<div class="sh-action-bar">
  <div class="sh-action-bar__group">
    @if (totalResults !== null) {
      <div class="sh-action-bar__group__item">
        @if (totalResults !== 0) {
          <h5 class="sh-clear-margin">
            {{ xxResultsLabelKey || "general.xx-results.other" | translate: { amount: totalResults } }}
          </h5>
        }
        @if (totalResults === 0) {
          <h5 class="sh-clear-margin">{{ noResultsLabelKey || "general.no-results.other" | translate }}</h5>
        }
      </div>
    }
  </div>
  <div class="sh-action-bar__group -sh-condense">
    @if (showSortSelect && (displayMode$ | async) !== displayModes.MAP) {
      @if (sortInfo$ | async) {
        <sh-sort-select
          class="sh-action-bar__group__item"
          [sortInfo]="sortInfo$ | async"
          [sortOptions]="sortOptions"
          (sortInfoChanged)="onSortInfoChanged($event)"
          [prefixMessage]="sortPrefixMessage"
          [loadingMsg]="sortLoadingMsg"
        ></sh-sort-select>
      }
    }
    @if (showViewToggle) {
      <sh-view-toggle
        class="sh-action-bar__group__item"
        [displayMode]="displayMode$ | async"
        [displayOptions]="displayOptions"
        (displayModeChanged)="onViewModeSelected($event)"
      ></sh-view-toggle>
    }
  </div>
</div>
